import React from 'react';
import { Discount } from '../../../../types/discounts';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import { getStoreIds } from '../../../../marketing/helpers';

interface StoreProps extends WithTranslation {
    discount: Discount;
}

const Stores = (
    {
        discount,
        t,
    }: StoreProps
) => {
    const storeIds = getStoreIds(discount) || [];
    const isAll = storeIds.length === 1 && storeIds[0] === '*';

    if (isAll) {
        return (
            <>
                <Header>{t('customers.customer.discounts.store')}</Header>
                <Value>{t('customers.customer.discounts.all')}</Value>
            </>
        );
    } else {
        return (
            <>
                <BlockHeader>{t('customers.customer.discounts.store')}</BlockHeader>
                <ul>
                    {storeIds.map((storeId, i) => (
                        <li key={i}>{storeId}</li>
                    ))}
                </ul>
            </>
        );
    }
};

const Header = styled.span`
    font-weight: 700;
    color: #46535E;
`;

const BlockHeader = styled(Header)`
    display: block;
`;

const Value = styled.span`
    margin-left: 8px;
`;

export default withTranslation()(Stores);
